import { Outlet } from 'react-router-dom';

export default function KnowledgeBase() {
  return (
    <>
      <Outlet />
    </>
  );
}
